var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNnIconFlagsCnDelivery = function SvgNnIconFlagsCnDelivery(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "nn-icon-flags-CN-delivery_svg__Lager_25",
    "data-name": "Lager 25",
    viewBox: "0 0 50.47 33.81"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".nn-icon-flags-CN-delivery_svg__cls-3{fill:#f6f900}"))), /*#__PURE__*/React.createElement("path", {
    d: "M.12.13h50.22v33.56H.12z",
    style: {
      fill: "red"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75 33.34v33.32H25V33.34zm.25-.25H24.77v33.82h50.46V33.09Z",
    style: {
      fill: "#87888a"
    },
    transform: "translate(-24.77 -33.09)"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m10.39 9.17 2.94-2.14H9.7L8.58 3.58 7.46 7.03H3.83l2.93 2.14-1.12 3.45 2.94-2.13 2.94 2.13zM17.39 4l1.18-.27-1.12-.48.11-1.2-.8.91-1.11-.47.62 1.03-.79.92 1.18-.27.62 1.04zM20.52 7.48l1.19.21-.84-.87.56-1.07-1.08.54-.85-.87.18 1.2-1.09.53 1.19.21.17 1.19zM20.85 12.08l.95-.74-1.21.04-.41-1.14-.34 1.17-1.2.04 1 .68-.33 1.16.95-.75 1 .68zM17.4 15.64l1.17-.32-1.13-.43.05-1.21-.75.95-1.13-.43.66 1.01-.75.95 1.16-.32.67 1.01z",
    className: "nn-icon-flags-CN-delivery_svg__cls-3"
  })));
};
export default SvgNnIconFlagsCnDelivery;